<template>
  <v-card>
    <v-card-title class="primary white--text">
      {{ title }}
      <v-spacer></v-spacer>
      <v-btn
        class="primary lighten-1 float-right"
        dark
        icon
        @click="$emit('close')"
      >
        <v-icon color="white--text">mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text
      style="border: 1px solid #ccc; width: 98%; margin: 10px auto 0"
    >
      <div id="preview">
        <iframe
          ref="pdfView"
          style="width: 100%; height: 100%"
          frameborder="0"
          scrolling="no"
          :src="initialDocFile"
        >
          <p>It appears your web browser doesn't support iframes.</p>
        </iframe>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "LetterPreview",
  data: () => ({
    instance: null,
    type: "office",
  }),
  props: {
    initialDocFile: { type: String },
    title: { type: String },
    previewDialog: { type: Boolean },
  },
  computed: {},
};
</script>

<style>
#preview {
  height: 80vh;
}
</style>
